import axios from "axios";

const spoonacularApi = axios.create({
    baseURL: "https://api.spoonacular.com/recipes",
    // headers: {: "1217248b68ff435cbabd6b66bb4014d2"}
})

// api.defaults.headers.common["x-api-key"] = "1217248b68ff435cbabd6b66bb4014d2"

export default spoonacularApi;